import whatsappApiExamples from '../docs_json/whatsapp_api_examples.json';

/**
 * Generate WhatsApp API code examples with dynamic values
 * @param {string} recipientNumber - The destination phone number
 * @param {string} phoneId - The WhatsApp phone ID
 * @param {string} token - Optional auth token value
 * @returns {Object} - Code examples for each supported language and response
 */
export const getWhatsAppApiExamples = (type = 'template', recipientNumber, phoneId) => {
  const examples = {};

  const requests = whatsappApiExamples[type].requests;
  Object.keys(requests).forEach((language) => {
    let example = requests[language];

    example = example
      .replace(/{{recipient_number}}/g, recipientNumber || '1234567890')
      .replace(/{{phone_id}}/g, phoneId || 'phone_id_value');

    examples[language] = example;
  });

  examples.response = whatsappApiExamples.response.json;

  return examples;
};
